<template>
  <div class="Calendar">
    <div class="select" @click.stop="handleClick" >
      <div class="calendar_select_box br4">
        <span><i class="iconfont icon-rili2"></i></span>
        <div>
          <span v-if="time.length==0" style="font-size:0.2rem">选择时间</span>
          <span v-else>{{time[0] | toDate}} - {{time[1] | toDate}}</span>
        </div>
        <span v-if="time.length>0" @click.stop="clearDate()" class="calendar_select_box_lcear"><i class="iconfont icon-qingchu"></i></span>
      </div>
    </div>
    <md-popup v-model="show" position="right" >
      <div class="calendar-box">
        <van-calendar ref="vanCalaendar" v-model="show" type="range" color="#31b158" title="选择时间" :allow-same-day="true" :min-date="minDate" :max-date="maxDate" :show-confirm="false" :poppable="false" :default-date="[new Date(),new Date()]" @confirm="onConfirm" />
      </div>
    </md-popup>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  model: {
    prop: "value",
    event: "setValue"
  },
  props:{
    value: {
      type: [Array,String],
      default: ""
    },
  },
  watch:{
    value:{
      handler(newval,oldval){
        this.time = newval || []
        if(!newval){
          this.$refs.vanCalaendar.reset()
        }
      },
      deep:true
    }
  },
  data(){
    return {
      show:false,
      minDate:new Date(new Date().getTime() - 6 * 30 * 86400*1000),
      maxDate:new Date(new Date().getTime()),
      time:this.value || []
    }
  },
  
  created(){

  },
  mounted(){
  },
  methods:{
    // 显示
    handleClick(){
      this.show = true
    },


    // 选择完成
    onConfirm(value){
      if(value){
        var s = value[0].getTime()/1000
        var e = value[1].getTime()/1000 + (86400 -1 )
        this.time = [s,e]
        this.$emit("setValue",[s,e])
        this.$emit("change",[s,e])
      }
      this.show = false
    },

    // 清除数据
    clearDate(){
      this.time = []
      this.$emit("setValue",'')
      this.$emit("change",'')
      this.show = false
    }
  },
}
</script>

<style scoped lang="less">
.Calendar{
  position: relative;
  display: inline-block;
  .select{
    font-size: 0.2rem;
    .calendar_select_box{
      width: 2.58rem;
      height: 0.36rem;
      padding: 0 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #e6e6e6;
      font-size: 0.16rem;
      color: #666;
      &>div{
        flex: 1;
      }
      &>span{
        width: 0.3rem;
        color: #999;
        text-align: left;
        i{
          font-size: 0.24rem;
        }
        &.calendar_select_box_lcear{
          text-align: right;
          i{
            font-size:0.2rem;
          }
        }
      }
    }
  }
  .calendar-box{
    width: 6rem;
    height: 100%;
    font-size: 0.20rem;
  }
}
</style>
